<!-- 
 01-01-2025
 Copyright (c) 2016 Aruba. All Rights Reserved.  
 -->
<form name="contactForm" role="form" novalidate (ngSubmit)="submitContact()" [formGroup]="contactForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-md-12 mb-4">
                <div [innerHTML]="descriptionText">
                    Ti invieremo
                    all'indirizzo e-mail inserito un codice di verifica
                </div>
            </div>
            <div class="col-12 col-sm-6">
                <div class="form-group">
                    <label  class="text-secondary" [innerHTML]="contactLabelText" for="contact">Email (non PEC)</label>
                    <ng-container *ngIf="cType === contactTypes.MOBILE">
                        <ap-input-mobile controlName="contact" (onMobileSubmitted)="mobileSubmitted($event)">
                        </ap-input-mobile>
                    </ng-container>
                    <ng-container *ngIf="cType === contactTypes.EMAIL">
                        <input id="contact" type="text" class="form-control" name="contact" formControlName="contact">
                    </ng-container>
                    <ng-container *ngIf="contactForm.get('contact')!.errors">
                        <div class="form-text text-danger" *ngIf="contactForm.get('contact')!.errors?.serverError">
                            {{ contactForm.get('contact')!.errors?.serverError }}
                        </div>
                        <ng-container *ngIf="cType === contactTypes.MOBILE">
                            <div class="form-text text-danger" *ngIf="contactForm.get('contact')!.errors?.mobileError">
                                {{ 'contacts.errors.mobile.i18nMobileInvalid' | translate }}
                            </div>
                        </ng-container>

                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer justify-content-start">
        <button type="submit" class="btn btn-lg btn-primary position-relative" 
        [disabled]="!contactForm.get('contact')!.valid || !contactForm.get('contact')!.value">
            <ngx-spinner name="contactFormBtn" size="small" [fullScreen]="false" type="ball-clip-rotate"></ngx-spinner>
            <span [innerHTML]="submitButtonText">Invia codice per email</span>
        </button>
        <button type="button" class="btn btn-link" (click)="goBack()" *ngIf="backButtonVisible"
            [innerHTML]="backButtonTxt"></button>
    </div>
</form>
